import React from "react";
import EditableText from "../edit/EditableText";
import PageCopyright from "../edit/PageCopyright";
import { PAGE_TITLE_STYLE } from "../edit/textStyles";

function TeamPage() {
  return (
    <div className="main-content" style={{ maxWidth: 800, margin: "0 auto", padding: 24 }}>
      <EditableText id="team.title" defaultContent="同工团队" defaultStyle={PAGE_TITLE_STYLE} />
      <h1 style={{ textAlign: "center", position: "absolute", left: "-9999px" }}>同工团队</h1>
      <section style={{ margin: "32px 0" }}>
        <EditableText
          id="team.pastor-title"
          as="h2"
          defaultContent="教会牧师-李晖"
          defaultStyle={{ color: "#0693e3", textAlign: "left" }}
        />
        <EditableText
          id="team.pastor-body"
          defaultContent={"李晖牧师, 2017年毕业于改革宗神学院（RTS），获道学硕士学位。从2018年开始在伊州的香槟植堂。\n喜爱上帝的话语，盼望帮助更多的人认识上帝和认识基督。和妻子郑瑛育有子女三人。"}
          defaultStyle={{ textAlign: "left" }}
        />
      </section>
      <section style={{ margin: "32px 0" }}>
        <EditableText
          id="team.staff-title"
          as="h2"
          defaultContent="教会同工"
          defaultStyle={{ color: "#0693e3", textAlign: "left" }}
        />
        <EditableText
          id="team.staff-body"
          defaultContent={"庄哲勤（Jer-Chin Chuang）\n教会服侍：目前带领周日英文主日学班, 学生团契的辅导。\n伊利诺伊大学讲师（University of Illinois instructor, English Sunday school teacher）。"}
          defaultStyle={{ textAlign: "left" }}
        />
      </section>
      <PageCopyright pageId="team" />
    </div>
  );
}

export default TeamPage;
